/** @module Apparel/SupplierRequestStructureItemTable */
define([
	"dojo/_base/declare",
	"Apparel/StructureItemTable"
], function(declare,StructureItemTable) {

	return declare(StructureItemTable, {
		TypeRelations: {
			"Season":"SRSeason",
			"Category1":"SRCategory1",
			"Category2":"SRCategory2",
			"Collection":"SRCollection"
		}
	});
});